import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { draftOrdersApi } from '../api/draft-orders-api';

import { draftOrderKeys } from './draft-order-keys';

/** Keeps the last preview on screen while the message being typed is fetched again. */
export function useDraftInvoicePreview(storeId: string, id: string, message: string) {
  return useQuery({
    queryKey: draftOrderKeys.invoicePreview(storeId, id, message),
    queryFn: () => draftOrdersApi.invoicePreview(storeId, id, message),
    placeholderData: keepPreviousData,
  });
}
